export async function resetScene() {
  //@ts-ignore
  const containerRef = window.containerRef;
  const canvasIframe = containerRef.current.contentWindow;

  canvasIframe.ClearScene();
}
